import axios from 'axios'
import {
  AddClientResponse,
  DeleteClientResponse,
  GetClientsResponse,
  GetCountersResponse,
  UpdateClientResponse,
} from '../@types/api'
import { Config } from '../utils/config'
import { LocalStorage } from '../utils/localStorage'

export interface UpdateClientPayload {}
export interface DeleteClientPayload {}
export interface DeleteClientPayload {
  id: string
}
export interface PauseClientPayload {
  id: string
}

export interface ActivateClientPayload {
  id: string
}

export interface AddClientPayload {
  client: string
  license: string
  expire: number
  for_tests?: boolean
  stopped?: boolean
  website: string
  pipeline_link: string
  labels?: string[]
  limits: {
    success: {
      alltime?: number | null
      year?: number | null
      month?: number | null
      day?: number | null
    }
  }
}
export interface UpdateClientPayload {
  id: string
  client?: string
  // license: string
  expire?: number
  for_tests?: boolean
  stopped?: boolean
  website?: string
  pipeline_link?: string
  labels?: string[]
  limits?: {
    success?: {
      alltime?: number
      year?: number
      month?: number
    }
  }
}

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.log('🚀 ~ file: api.ts ~ line 38 ~ error', error)
    if (error.response.status === 401 || error.response.status === 403) {
      window.location.href = '/'
      LocalStorage.cleanGoogleToken()
    }
    return error
  },
)

export class Api {
  static async getCounters(token: string) {
    const response = axios.get<GetCountersResponse>(
      `${Config.host}/licenses/${token}/counters`,
    )
    return response
  }

  static async getClients(token: string) {
    const response = axios.get<GetClientsResponse>(
      `${Config.host}/api/v1/client`,
    )
    return response
  }

  static async addClient(payload: AddClientPayload) {
    const response = axios.post<AddClientResponse>(
      `${Config.host}/api/v1/client`,
      payload,
    )
    return response
  }

  static async updateClient(clientId: string, payload: UpdateClientPayload) {
    const response = axios.put<UpdateClientResponse>(
      `${Config.host}/api/v1/client/${clientId}`,
      payload,
    )
    return response
  }

  static async deleteClient(clientId: string) {
    const response = axios.delete<DeleteClientResponse>(
      `${Config.host}/api/v1/client/${clientId}`,
    )
    return response
  }

  static async pauseClient(clientId: string) {
    const response = axios.put<UpdateClientResponse>(
      `${Config.host}/api/v1/client/${clientId}`,
      {
        stopped: true,
      },
    )
    return response
  }

  static async activateClient(clientId: string) {
    const response = axios.put<UpdateClientResponse>(
      `${Config.host}/api/v1/client/${clientId}`,
      {
        stopped: false,
      },
    )
    return response
  }
}
